
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AppAdministratorOrganizationsRootListIndexVue from "@/views/app/administrator/organizations/root/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AppAdministratorOrganizationsRootListIndexVue
  },
})
export default class AppAdministratorOrganizationsRootIndexVue extends Vue {}
